// extracted by mini-css-extract-plugin
export default {"gohome":"index_gohome_AY5w6"};